import { Link } from "react-router";
import SectionLabel from "../components/SectionLabel";
import { Arrow } from "../components/Icons";
import { portfolio } from "../data/portfolio";

export default function ContactCta() {
  return (
    <section id="contact" className="contact-cta section container">
      <SectionLabel index="04">Open to what’s next</SectionLabel>
      <div className="contact-cta-content">
        <h2>
          Let’s make
          <br />
          something <em>move.</em>
        </h2>
        <Link
          className="contact-circle"
          to="/contact"
          aria-label="Start a conversation"
        >
          <Arrow diagonal />
        </Link>
      </div>
      <div className="contact-cta-bottom">
        <p>{portfolio.availability}</p>
        <Link className="text-link" to="/contact">
          Start a conversation <Arrow diagonal />
        </Link>
        <span className="mono">
          <span className="status-dot" />
          {portfolio.location}
        </span>
      </div>
    </section>
  );
}
